<div class="main-card">
    <div class="row">
      <app-tqw-list-looping [config]="{list:config.list!}">
        <ng-template #listItem let-item="item" let-i="index">
          <div class="col-{{config.colsCount || 6}} ">
            <app-tqw-view-item *ngIf="!viewItem" [config]="item"></app-tqw-view-item>
            <ng-template *ngTemplateOutlet="viewItem; context: { item: item, index: i}">
            </ng-template>
          </div>
        </ng-template>
      </app-tqw-list-looping>
    </div>
  </div>
  